import React from 'react';
import PropTypes from 'prop-types';
import { MemoryRouter, Route, Switch } from 'react-router-dom';

import { Messages, Message, Section } from './Screens/index';
import { WindowHeader, CustomCss, Window } from './Components/index';
import { Notifications, Tickets } from '../Converse/Screens/index';
import { IframeModal } from '../Converse/Components/index';
import { RouteChanger, AuthChanger } from '../../Components/index';
import { Settings } from '../../Screens/index';
import { useBot } from '../../hooks/index';

const Embed = ({ start = '/window/body/messages', path = null }) => {
  const { iframeModal } = useBot();

  return (
    <MemoryRouter initialEntries={[start]}>
      <RouteChanger path={path} />
      <AuthChanger />
      <CustomCss />
      <Window>
        {iframeModal && <IframeModal />}
        <Switch>
          <Route path="/window">
            <Route exact path="/window/section/:id" component={Section} />
            <Route exact path="/window/messages/:id" component={Message} />
            <Route path="/window/body">
              <WindowHeader />
              <Route exact path="/window/body/messages" component={Messages} />
              <Route
                exact
                path="/window/body/notifications"
                component={Notifications}
              />
              <Route exact path="/window/body/tickets" component={Tickets} />
              <Route exact path="/window/body/settings" component={Settings} />
            </Route>
          </Route>
        </Switch>
      </Window>
    </MemoryRouter>
  );
};

Embed.propTypes = {
  start: PropTypes.string,
  path: PropTypes.string
};

export default Embed;
